import { Pipe, PipeTransform } from '@angular/core';
import { getActivityGlyphSection } from './activity.functions';

@Pipe({
  name: 'activityGlyphSection'
})
export class ActivityGlyphSectionPipe implements PipeTransform {
    transform(activity?: string): string {
        return getActivityGlyphSection(activity);
    }
};